import React, { Component } from "react";
import { Form, Input } from "antd";

class FormItemRoutingNumber extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <Form.Item
        label={this.props.label}
        name={this.props.name}
        rules={[
          { required: true, message: "Please input " + this.props.name },
          {
            min: 9,
            max: 9,
            message: "Routing number must be 9 characters.",
          },
        ]}
        onChange={this.props.onChange}
        initialValue={this.props.initialValue}
      >
        <Input />
      </Form.Item>
    );
  }
}

export default FormItemRoutingNumber;
